import React from "react";
import "./Loader.css";
const Loader = () => {
  return (
    <div className="loadingPage">
      <div className="loadingCircle"></div>
    </div>
  );
};

export default Loader;